import { render } from "./AboutSection.vue?vue&type=template&id=4185ec7a&scoped=true"
const script = {}

import "./AboutSection.vue?vue&type=style&index=0&id=4185ec7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4185ec7a"]])

export default __exports__